import RouteLog from "@/components/RouteLog";

export default {
  install(Vue) {
    const RouteLogClass = Vue.extend(RouteLog);

    let isMounted = false;
    let instance;

    function $routeLog() {
      if (!isMounted) {
        instance = new RouteLogClass();
        instance.$mount();
        document.querySelector("body").appendChild(instance.$el);
        isMounted = true;
      }

      return instance;
    }

    Vue.$routeLog = Vue.prototype.$routeLog = $routeLog;
  }
};
